import React from 'react';
import styles from './ccf-customer-card-address.module.scss';
import { activeContactSelector } from '../../ccf-inbox.slice';
import { useSelector, useDispatch } from 'react-redux';
import {
  CcfEditBookIcon,
  CcfDoubleArrowIcon,
  CcfBox,
  CcfAccordion,
  CcfAccordionSummary,
  CcfAccordionDetails,
} from '@nice-ccf/ui-controls';
import { useTranslator } from '@nice-ccf/ui-controls';
import { getApplicationDirection } from '@nice-ccf/ui-components';
import { useTheme, Direction, IconButton } from '@mui/material';
import customerCardStyles from '../ccf-customer-card.styles';
/* eslint-disable-next-line */
export interface CcfCustomerAddressProps {}

/**
 * CcfCustomerAddress - used to display customer address in AppSpace
 * @param props --?-CcfCustomerAddressProps
 * @example - <CcfCustomerAddress />
 */
export function CcfCustomerAddress(props?: CcfCustomerAddressProps) {
  const profileData = useSelector(activeContactSelector);
  const [expanded, setExpanded] = React.useState('address');
  const appDirection: Direction = useSelector(getApplicationDirection);
  const theme = useTheme();
  const stylesAccordion = customerCardStyles(theme);
  const [translate, locale] = useTranslator();

  /**
   * handleChange Event - used to expand and collapse of address accordion
   * @param panel- 'address'
   * @param event - changeevent
   * @param newExpanded - boolean
   * @example - handleChange(panel)
   */
  const handleChange =
    (panel: string) =>
   {
      setExpanded(expanded === 'address' ? '' : panel);
    };

  return (
    <section>
      {profileData && (
        <CcfAccordion
          square
          expanded={expanded === 'address'}
          onChange={() => handleChange('address')}
          sx={stylesAccordion.accordionContainer}
        >
          <CcfAccordionSummary
            expandIcon={
              <CcfDoubleArrowIcon sx={stylesAccordion.expandedIcon} />
            }
            aria-controls="address-content"
            id="agent_appSpace_address"
            sx={
              expanded === 'address'
                ? stylesAccordion.accordionHeaderExpand
                : stylesAccordion.ccfAppSpaceAccordionHeader
            }
          >
            <CcfBox component="div" className={styles.contactAddress}>
              <span className={styles.addressTitle}>{translate('contactCardAddress')}</span>
            </CcfBox>
          </CcfAccordionSummary>
          <CcfAccordionDetails className={styles.addressDetails}>
            <CcfBox component="div" className={styles.addressInfo}>
              <CcfBox className={styles.contactAddress}>
                {profileData.customer.customerPrimaryAddress}
              </CcfBox>
              <CcfBox component="div" className={styles.editIcon}>
                <IconButton className={styles.editIconBtn}>
                  <CcfEditBookIcon />
                </IconButton>
              </CcfBox>
            </CcfBox>
          </CcfAccordionDetails>
        </CcfAccordion>
      )}
      <CcfBox component="div" className={styles.bottomBorder}></CcfBox>
    </section>
  );
}

export default CcfCustomerAddress;
